import { useState, useEffect } from 'react';


// APIリンクの生成
export async function requestApi(
    params: Record<string, any>
): Promise<any> {
    const res = await fetch('/backend/api', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params),
      credentials: 'include',
    });
    if (!res.ok) throw new Error('未ログイン');
    const resp = await res.json();
    return resp;
}


// 日付を「MM/DD(曜日)」にフォーマットする
export function formatDate(dateStr: string): string {
    const date = new Date(dateStr);
    const options: Intl.DateTimeFormatOptions = { 
      month: '2-digit', 
      day: '2-digit', 
      weekday: 'short'
    };
    return date.toLocaleDateString('ja-JP', options)
      .replace('日', '日')
      .replace('月', '月')
      .replace('火', '火')
      .replace('水', '水')
      .replace('木', '木')
      .replace('金', '金')
      .replace('土', '土');
}
  
// 時間を「HH:MM」にフォーマットする
export function formatTime(timeStr: string): string {
  return timeStr.slice(0, 5);
}
// 分数を追加して時間を「HH:MM」にフォーマットする
export function formatTimeAddMin(timeStr: string, addMin: number): string {
  const [hours, minutes] = timeStr.split(':').map(Number);
  const totalMinutes = hours * 60 + minutes + addMin;
  // 24時間制に変更
  const newHours = Math.floor(totalMinutes / 60) % 24;
  const newMinutes = totalMinutes % 60;
  // パディングして "HH:MM" 形式で返す
  return `${String(newHours).padStart(2, '0')}:${String(newMinutes).padStart(2, '0')}`;
}


// APIの連続実行を防ぐ(入力度にAPIをたたく場合など)
export function useDebouncedValue<T>(value: T, delay: number) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => setDebouncedValue(value), delay);
    return () => clearTimeout(handler);
  }, [value, delay]);

  return debouncedValue;
}


// Bodyスクロールの制御
export function bodyScrollCntl(isScroll: boolean) {
  if (!isScroll) {
    // スクロール不可
    document.body.style.overflow = 'hidden';
    document.body.style.touchAction = 'none'; //iOS対応
  } else {
    // スクロール可
    document.body.style.overflow = '';
    document.body.style.touchAction = '';
  }
}